/* This file is only used in V2 */
import _values from 'lodash/values';

export const GE_ORDER_STATE = {
  // Queueing ...
  Queueing: 'QUEUEING',
  // New ...
  New: 'NEW',
  // PendingScheduling ...
  PendingScheduling: 'PENDING_SCHEDULING',
  // Scheduling ...
  Scheduling: 'SCHEDULING',
  // Delivering ...
  Delivering: 'DELIVERING', // for MSD
  // ScheduleFailed ...
  ScheduleFailed: 'SCHEDULE_FAILED',
  // PendingPickUp ...
  PendingPickUp: 'PENDING_PICKUP',
  // PickingUp ...
  PickingUp: 'PICKING_UP',
  // PendingDropOff ...
  PendingDropOff: 'PENDING_DROP_OFF',
  // DroppingOff ...
  DroppingOff: 'DROPPING_OFF',
  // FailedDelivery ...
  FailedDelivery: 'FAILED_DELIVERY',
  // PendingReturn ...
  PendingReturn: 'PENDING_RETURN',
  // Returning ...
  Returning: 'RETURNING',
  // Returned ...
  Returned: 'RETURNED',
  // Completed ...
  Completed: 'COMPLETED',
  // OperatorCancelled ...
  OperatorCancelled: 'OPERATOR_CANCELLED',
  // SenderCancelled ...
  SenderCancelled: 'SENDER_CANCELLED',
  // DriverCancelled is not a OrderState that will be persisted in our system, just for displaying purpose on mobile
  DriverCancelled: 'DRIVER_CANCELLED',
  // DriverCancelledPickUp is not a OrderState that will be persisted in our system, just for other systems to use
  DriverCancelledPickUp: 'DRIVER_CANCELLED_PICKUP',
  // DriverCancelledDropOff is not a OrderState that will be persisted in our system, just for other systems to use
  DriverCancelledDropOff: 'DRIVER_CANCELLED_DROPOFF',
};

export const GE_ORDER_ONGOING_STATES = [
  GE_ORDER_STATE.Queueing,
  GE_ORDER_STATE.New,
  GE_ORDER_STATE.PendingScheduling,
  GE_ORDER_STATE.Scheduling,
  GE_ORDER_STATE.PendingPickUp,
  GE_ORDER_STATE.Delivering,
  GE_ORDER_STATE.PickingUp,
  GE_ORDER_STATE.PendingDropOff,
  GE_ORDER_STATE.DroppingOff,
  GE_ORDER_STATE.FailedDelivery,
  GE_ORDER_STATE.PendingReturn,
  GE_ORDER_STATE.Returning,
];

export const GE_ORDER_BOOK_AGAIN_STATES = [
  GE_ORDER_STATE.ScheduleFailed,
  GE_ORDER_STATE.Returned,
  GE_ORDER_STATE.Completed,
  GE_ORDER_STATE.OperatorCancelled,
  GE_ORDER_STATE.SenderCancelled,
  GE_ORDER_STATE.DriverCancelled,
  GE_ORDER_STATE.DriverCancelledPickUp,
  GE_ORDER_STATE.DriverCancelledDropOff,
];

// GE_WEB order state will be mapped to GE order state in BE
// NOTE: GE state SCHEDULING will be returned as SCHEDULED
export const GE_WEB_ORDER_STATE = {
  AllStatus: 'ALL_STATUS',
  ActiveDelivery: 'ACTIVE_DELIVERY', // { New, Scheduling, PendingPickUp, PickingUp, PendingDropOff, GE_ALLOCATING },
  Scheduled: 'SCHEDULED', // { New, Scheduling, PendingPickUp },
  InTransit: 'IN_TRANSIT', // { PendingPickUp, PickingUp, PendingDropOff }
  FindingDriver: 'FINDING_DRIVER', // { GE_ALLOCATING }
  Cancelled: 'CANCELLED', // { OperatorCancelled, SenderCancelled, DriverCancelled, DriverCancelledPickUp, DriverCancelledDropOff },
  NoDriver: 'NO_DRIVER', // { ScheduleFailed, GE_UNALLOCATED },
  Unallocated: 'UNALLOCATED', // { GE_UNALLOCATED }
  Allocating: 'ALLOCATING', // { GE_ALLOCATING }
  Unknown: 'UNKNOWN',
};

// use for status check in msd step
export const MSD_STEP_STATE = {
  Todo: 'TODO',
  Ongoing: 'ONGOING',
  Completed: 'COMPLETED',
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
};

export const GE_WEB_MAP_GE_ORDER_STATE = {
  [GE_WEB_ORDER_STATE.AllStatus]: _values(GE_ORDER_STATE),
  [GE_WEB_ORDER_STATE.ActiveDelivery]: [
    GE_ORDER_STATE.New,
    GE_ORDER_STATE.Scheduling,
    GE_ORDER_STATE.Delivering,
    GE_ORDER_STATE.PendingPickUp,
    GE_ORDER_STATE.PickingUp,
    GE_ORDER_STATE.DroppingOff,
    GE_ORDER_STATE.PendingDropOff,
    GE_WEB_ORDER_STATE.Allocating,
    GE_WEB_ORDER_STATE.Scheduled,
    GE_WEB_ORDER_STATE.Unknown,
  ],
  [GE_WEB_ORDER_STATE.Scheduled]: [
    GE_ORDER_STATE.New,
    GE_ORDER_STATE.PickingUp,
    GE_ORDER_STATE.PendingDropOff,
    GE_WEB_ORDER_STATE.Scheduled,
  ],
  [GE_WEB_ORDER_STATE.InTransit]: [
    GE_ORDER_STATE.Delivering,
    GE_ORDER_STATE.PendingPickUp,
    GE_ORDER_STATE.PickingUp,
    GE_ORDER_STATE.PendingDropOff,
    GE_ORDER_STATE.DroppingOff,
  ],
  [GE_WEB_ORDER_STATE.FindingDriver]: [GE_WEB_ORDER_STATE.Allocating],
  [GE_WEB_ORDER_STATE.Cancelled]: [
    GE_ORDER_STATE.OperatorCancelled,
    GE_ORDER_STATE.SenderCancelled,
    GE_ORDER_STATE.DriverCancelled,
    GE_ORDER_STATE.DriverCancelledPickUp,
    GE_ORDER_STATE.DriverCancelledDropOff,
  ],
  [GE_WEB_ORDER_STATE.NoDriver]: [
    GE_ORDER_STATE.ScheduleFailed,
    GE_WEB_ORDER_STATE.Unallocated,
  ],
  [GE_WEB_ORDER_STATE.Unallocated]: [GE_WEB_ORDER_STATE.Unallocated],
  [GE_WEB_ORDER_STATE.Allocating]: [GE_WEB_ORDER_STATE.Allocating],
  [GE_WEB_ORDER_STATE.Unknown]: [],
};

export const ONGOING_ORDER_STATES = [
  {
    state: GE_WEB_ORDER_STATE.ActiveDelivery,
    text: 'v2.orderState.geWebState.ACTIVE_DELIVERY',
  },
  {
    state: GE_WEB_ORDER_STATE.Scheduled,
    text: 'v2.orderState.geWebState.SCHEDULED',
  },
  {
    state: GE_WEB_ORDER_STATE.FindingDriver,
    text: 'v2.orderState.geWebState.FINDING_DRIVER',
  },
  {
    state: GE_WEB_ORDER_STATE.InTransit,
    text: 'v2.orderState.geWebState.IN_TRANSIT',
  },
  {
    state: GE_ORDER_STATE.PickingUp,
    text: 'v2.orderState.geState.PICKING_UP',
  },
  {
    state: GE_ORDER_STATE.DroppingOff,
    text: 'v2.orderState.geState.DROPPING_OFF',
  },
];

export const COMPLETED_ORDER_STATES = [
  {
    state: GE_WEB_ORDER_STATE.AllStatus,
    stateToQuery: [
      GE_ORDER_STATE.Completed,
      GE_ORDER_STATE.FailedDelivery,
      GE_WEB_ORDER_STATE.Cancelled,
      GE_WEB_ORDER_STATE.NoDriver,
      GE_ORDER_STATE.PendingReturn,
      GE_ORDER_STATE.Returning,
      GE_ORDER_STATE.Returned,
    ],
    text: 'v2.orderState.geWebState.ALL_STATUS',
  },
  {
    state: GE_ORDER_STATE.Completed,
    text: 'v2.orderState.geState.COMPLETED',
  },
  {
    state: GE_WEB_ORDER_STATE.Cancelled,
    text: 'v2.orderState.geWebState.CANCELLED',
  },
  {
    state: GE_ORDER_STATE.FailedDelivery,
    text: 'v2.orderState.geState.FAILED_DELIVERY',
  },
  {
    state: GE_WEB_ORDER_STATE.NoDriver,
    text: 'v2.orderState.geWebState.NO_DRIVER',
  },
  {
    state: GE_ORDER_STATE.PendingReturn,
    text: 'v2.orderState.geState.PENDING_RETURN',
  },
  {
    state: GE_ORDER_STATE.Returning,
    text: 'v2.orderState.geState.RETURNING',
  },
  {
    state: GE_ORDER_STATE.Returned,
    text: 'v2.orderState.geState.RETURNED',
  },
];

export const ALLOWED_TO_CANCEL_STATES = [
  GE_WEB_ORDER_STATE.Scheduled,
  GE_ORDER_STATE.Queueing,
  GE_ORDER_STATE.New,
  GE_ORDER_STATE.PendingPickUp,
  GE_ORDER_STATE.PickingUp,
  GE_ORDER_STATE.Scheduling,
];

export const NEW_ONGOING_ORDER_STATE_FILTER = {
  [GE_WEB_ORDER_STATE.ActiveDelivery]: {
    text: 'v2.orderState.geWebState.ACTIVE_DELIVERY',
  },
  [GE_WEB_ORDER_STATE.Scheduled]: {
    text: 'v2.orderState.geWebState.SCHEDULED',
    matchStates: [GE_ORDER_STATE.New, GE_WEB_ORDER_STATE.Scheduled],
  },
  [GE_ORDER_STATE.Delivering]: {
    text: 'v2.orderState.geState.DELIVERING',
    matchStates: [GE_ORDER_STATE.Delivering],
  },
  [GE_ORDER_STATE.PickingUp]: {
    text: 'v2.orderState.geState.PICKING_UP',
    matchStates: [GE_ORDER_STATE.PickingUp],
  },
  [GE_ORDER_STATE.DroppingOff]: {
    text: 'v2.orderState.geState.DROPPING_OFF',
    matchStates: [GE_ORDER_STATE.DroppingOff],
  },
  [GE_ORDER_STATE.PendingReturn]: {
    text: 'v2.orderState.geState.PENDING_RETURN',
    matchStates: [GE_ORDER_STATE.PendingReturn],
  },
  [GE_ORDER_STATE.Returning]: {
    text: 'v2.orderState.geState.RETURNING',
    matchStates: [GE_ORDER_STATE.Returning],
  },
};

export const NEW_COMPLETED_ORDER_STATE_FILTER = {
  [GE_WEB_ORDER_STATE.AllStatus]: {
    text: 'v2.orderState.geWebState.ALL_STATUS',
  },
  [GE_ORDER_STATE.Completed]: {
    text: 'v2.orderState.geState.COMPLETED',
    matchStates: [GE_ORDER_STATE.Completed],
  },
  [GE_WEB_ORDER_STATE.Cancelled]: {
    text: 'v2.orderState.geWebState.CANCELLED',
    matchStates: [
      GE_WEB_ORDER_STATE.Cancelled,
      GE_ORDER_STATE.OperatorCancelled,
      GE_ORDER_STATE.SenderCancelled,
      GE_ORDER_STATE.DriverCancelled,
      GE_ORDER_STATE.DriverCancelledPickUp,
      GE_ORDER_STATE.DriverCancelledDropOff,
    ],
  },
  [GE_WEB_ORDER_STATE.NoDriver]: {
    text: 'v2.orderState.geWebState.NO_DRIVER',
    matchStates: [
      GE_ORDER_STATE.ScheduleFailed,
      GE_WEB_ORDER_STATE.Unallocated,
      GE_WEB_ORDER_STATE.NoDriver,
    ],
  },
  [GE_ORDER_STATE.Returned]: {
    text: 'v2.orderState.geState.RETURNED',
    matchStates: [GE_ORDER_STATE.Returned],
  },
};

// https://wiki.grab.com/pages/viewpage.action?spaceKey=EXPRESS&title=New+PAX+Cancellation+Rules#NewPAXCancellationRules-Contents
export const FIRST_TIME_LIMIT_CANCELLABLE_STATES = [
  GE_WEB_ORDER_STATE.Scheduled,
  GE_ORDER_STATE.Queueing,
  GE_ORDER_STATE.New,
];

export const SECOND_TIME_LIMIT_CANCELLABLE_STATES = [
  GE_WEB_ORDER_STATE.Scheduled,
  GE_ORDER_STATE.Queueing,
  GE_ORDER_STATE.New,
  GE_WEB_ORDER_STATE.Allocating,
  GE_ORDER_STATE.PendingPickUp,
  GE_ORDER_STATE.PickingUp,
];

export const ABOVE_TIME_LIMITS_CANCELLABLE_STATES = [
  GE_WEB_ORDER_STATE.Scheduled,
  GE_ORDER_STATE.Queueing,
  GE_ORDER_STATE.New,
  GE_WEB_ORDER_STATE.Allocating,
];

// filter by order type
export const ORDER_TYPES = {
  ALL: 'ALL',
  REGULAR: 'REGULAR',
  SHOPIFY: 'SHOPIFY',
  APP: 'APP',
  MEXAPP: 'MEXAPP',
};

// filter by third party source
export const THIRD_PARTY_SOURCE_ORDER_TYPES = {
  REGULAR: '',
  SHOPIFY: 'shopify',
};

export const ORDER_TYPES_SOURCE_ENUMS = {
  APP: -1,
  REGULAR: 0,
  SHOPIFY: 1,
  MEXAPP: 2,
};
